import Vue from 'vue';

export default context =>
  // context.code,
   Vue.$http.get('/airbnbxml/webhook?event=booking')
    .then((response) => {
      console.log(response.data, '[GET] /airbnbxml/webhook');
    })
    .catch((error) => {
      toastr.error(error.response.data.msg);
    })
    .finally(() => {
    });



// WEBPACK FOOTER //
// ./src/app/services/airbnb/webhook.js